<div class="h-100" #container>
  <div [id]="playerId"></div>
</div>
